var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "showSmallScreenOnly", class: _vm.colorBottomButton },
      [
        _c(
          "f7-fab",
          {
            staticClass:
              "leftfav button-fab bottomButton floatingButtonToolbarBlank",
            on: {
              click: function ($event) {
                return _vm.$emit("startCSVextraction")
              },
            },
          },
          [_c("i", { staticClass: "fa-light fa-file-lines" })]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass:
          "showLargeScreenOnly milkyBlockBlack new-button-white firstBlock pull-right",
        on: {
          click: function ($event) {
            return _vm.$emit("startCSVextraction")
          },
        },
      },
      [
        _c("i", { staticClass: "fa-light fa-file-lines" }),
        _vm._v(" "),
        _c("span", { staticClass: "fab-label" }, [
          _vm._v(_vm._s(_vm.$t("common.extract_csv"))),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }